import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { AddNewTalentColoredIcon, EditIcon, MultiplePagesDeleteIcon } from '../assets/icons';
import Button from '../components/Button';
import userStore from '../stores/userStore';
import { PiWarningCircleFill } from "react-icons/pi";
import moment from 'moment';
import generalStore from '../stores/generalStore';

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const Users = observer(class Users extends Component {
  state = {
    showDeleteModal: false,
    userToDelete: null,
    searchQuery: "",  
    filteredUsers: [],  
    showSearchInput: false,  
  };

  componentDidMount() {
    userStore.getUsers().then(() => {
      this.setState({ filteredUsers: userStore.users });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filteredUsers !== userStore.users) {
      this.setState({ filteredUsers: userStore.users });
    }
  }

  handleSearch = debounce((query) => {
    const filteredUsers = userStore.users.filter(user => {
      return user.employeeName.toLowerCase().includes(query.toLowerCase()) ||
        (user.email && user.email.toLowerCase().includes(query.toLowerCase())) ||
        (user.designation && user.designation.toLowerCase().includes(query.toLowerCase()));
    });
    this.setState({ filteredUsers });
  }, 500);

  handleSearchInputChange = (e) => {
    const query = e.target.value;
    this.setState({ searchQuery: query });
    this.handleSearch(query);
  };

  calculateAge = (date) => {
    const birthDate = moment(date);
    const today = moment();
    return today.diff(birthDate, 'years');
  };

  toggleDeleteModal = (user = null) => {
    this.setState({ showDeleteModal: !this.state.showDeleteModal, userToDelete: user });
  };

  handleDelete = () => {
    const { userToDelete } = this.state;
    if (userToDelete) {
      userStore.deleteUser(userToDelete.empId, userToDelete.email).then((data) => {
        this.setState({ filteredUsers: data });
      });
      this.toggleDeleteModal();
    }
  };

  render() {
    return (
      <div className='bg-[#F2F4F8]'>
        <div className='flex justify-end mx-6 py-3 gap-3 lg:gap-6'>
          {/* Desktop Button */}
          <Button className="hidden md:flex rounded-md" onClick={() => {
            userStore.setAddNewUserModalVisible(true);
          }} icon={AddNewTalentColoredIcon} title={"Add New"} />
          {/* Mobile Button */}
          <Button onClick={() => {
            userStore.setAddNewUserModalVisible(true);
          }} className="flex md:hidden rounded-md" icon={AddNewTalentColoredIcon} />

          {/* <Button className="hidden md:flex rounded-md" icon={SearchColoredIcon} title={"Search"} onClick={() => this.setState({ showSearchInput: !this.state.showSearchInput })} />
          <Button className="flex md:hidden rounded-md" icon={SearchColoredIcon} onClick={() => this.setState({ showSearchInput: !this.state.showSearchInput })} />
         */}
        </div>

        <div className='flex flex-1 h-screen bg-white lg:mx-6'>
          <div className='w-full h-full p-5 box-border'>
            <div className='flex flex-row justify-between items-center py-3 lg:py-6 gap-1'>
              <div className='flex justify-between flex-row items-center gap-1'>
                <span className='font-medium text-base text-black'>Users</span>
                <span className='font-normal text-xs text-white py-1 px-2 rounded-full lg:rounded-xl bg-[#F89A1F]'>{this.state.filteredUsers?.length}</span>
              </div>
              {this.state.showSearchInput && (
                <div className="flex justify-center">
                  <input
                    type="text"
                    className="border border-black/60 placeholder-black/80 rounded-md px-3 py-2  max-w-48 lg:w-full lg:max-w-lg"
                    placeholder="Search users..."
                    value={this.state.searchQuery}
                    onChange={this.handleSearchInputChange}
                  />
                </div>
              )}
            </div>

            <table className='shrink-0 w-full bg-transparent border text-center'>
              <thead>
                <tr className='bg-[#FCD49F] flex flex-1 justify-around'>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex flex-1 justify-center'>User Name</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex-1 justify-center hidden sm:flex'>Email</th>
                  <th className='font-medium text-xs lg:text-sm text-[#130D0D] py-3 flex flex-1 justify-center'>Action</th>
                </tr>
              </thead>
              <tbody className='flex flex-col flex-1 justify-around'>
                {
                  userStore.users.map((user) => (
                    user && (
                      <tr key={user?.empId} className='flex flex-1 justify-around border-b border-[#DDE1E6] py-2 hover:bg-black/[0.03]'>
                        <td className='flex flex-1 '>
                          <div className='flex flex-1 flex-row gap-x-4 items-center pl-3'>
                            <div className='flex flex-1 flex-row gap-x-2 items-center'>
                              {
                                user?.profileImagePath ? <img src={process.env.REACT_APP_BASE_URL + "/" + user.profileImagePath} className='w-10 h-10 rounded-full' alt={user?.employeeName} />
                                  :
                                  <div className='w-10 h-10 rounded-full bg-gray-200 flex justify-center items-center text-sm text-black/50 select-none'>{generalStore.getInitials(user?.employeeName)}</div>
                                }
                              <div className='flex flex-col items-start'>
                                <span className='font-medium text-sm text-[#21272A] text-left'>{user?.employeeName}</span>
                                <span className='font-normal text-xs text-[#697077]'>{user?.designation}</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className='flex-1 justify-center items-center font-normal text-sm text-[#130D0D] hidden sm:flex'>{user?.email}</td>

                        <td className='flex flex-1 justify-center items-center '>
                          <div className='flex flex-row gap-6'>
                            <button onClick={() => {
                              userStore.setUpdateUserModalVisible(true);
                              userStore.setCurrentUser(user);
                            }} className='w-5'>
                              <img className='w-5' src={EditIcon} alt="Edit" />
                            </button>
                            <button onClick={() => this.toggleDeleteModal(user)} className='w-5'>
                              <img className='w-5' src={MultiplePagesDeleteIcon} alt="Delete" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>

        {/* Delete Modal */}
        {this.state.showDeleteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white rounded-lg p-5 w-[22rem]">
              <div className='flex flex-row justify-start items-center gap-x-2 mb-4'>
                <PiWarningCircleFill color='#F89A1F' />
                <span className='font-normal text-sm'>Are you sure you want to delete this user?</span>
              </div>
              <div className="flex justify-end gap-4">
                <button onClick={this.toggleDeleteModal} className='border border-[#D9D9D9] bg-white rounded-sm'>
                  <span className='font-normal text-sm px-3'>No</span>
                </button>
                <button onClick={this.handleDelete} className='border border-black bg-black rounded-sm'>
                  <span className='font-normal text-sm px-3 text-white'>Yes</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
});

export default Users;

